import React, { useEffect, useState } from 'react';
import ProductionListComponent from './ProductionListComponent';
import { withRouter, Link } from 'react-router-dom';
import queryString from 'query-string';
import * as BbsService from '../../../services/Bbs.service';
import * as ListHelper from '../../../helpers/List.helper';
import stripHtml from 'string-strip-html';

const ProductionListContainer = props => {

    const [list, setList] = useState([]);
    const [page, setPage] = useState(1);
    const [paginationObj, setPaginationObj] = useState(null);

    useEffect(_ => {
        const init = async page => {
            let { totalCount, list } = await BbsService.getList(page, ['NMP-PRODUCTION'])
            for (let i = 0; i < list.length; i++) {
                list[i].context = stripHtml(list[i].context).result;
            }
            let paginationObj = ListHelper.makePaginationObj(totalCount, page, 10, 10);
            setPage(page);
            setPaginationObj(paginationObj)
            setList(list);
        }

        let params = queryString.parse(props.location.search);
        let page = parseInt(params['page'] ? params['page'] : 1);
        init(page)
    }, [props])

    const onClickArticle = (id) => {
        props.history.push(`/production/${id}`);
    }

    const onClickBtnPageNum = (pageNum) => {
        console.log(pageNum);
        props.history.push(`/production?page=${pageNum}`)
    }

    return (
        <ProductionListComponent
            list={list}
            onClickArticle={onClickArticle}
            paginationObj={paginationObj}
            onClickBtnPageNum={onClickBtnPageNum}
            {...props}
        />
    )
}

export default withRouter(ProductionListContainer);